// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const IntegrationsService = {
    ListIntegrations(fn, req) {
        return fn(`/syncapp/integrations-service/integrations?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetIntegration(fn, req) {
        try {
            fm.validateUrlParam(req["integrationId"], "integrationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/integrations/${req["integrationId"]}?${fm.renderURLSearchParams(req, ["integrationId"])}`, { method: "GET" });
    },
    GetIntegrationByName(fn, req) {
        try {
            fm.validateUrlParam(req["integrationName"], "integrationName");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/integrations/${req["integrationName"]}?${fm.renderURLSearchParams(req, ["integrationName"])}`, { method: "GET" });
    },
    UpdateIntegrationsDetails(fn, req) {
        return fn(`/syncapp/integrations-service/integration-details`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListDataSourcesByLocationID(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/locations/${req["locationId"]}/data-sources?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    GetDataSourceBySourceID(fn, req) {
        try {
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/sources/${req["sourceId"]}/data-source?${fm.renderURLSearchParams(req, ["sourceId"])}`, { method: "GET" });
    },
    CreateSyncAppDataSource(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/locations/${req["locationId"]}/data-sources/sync-app`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CreateCSVDataSource(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/locations/${req["locationId"]}/data-sources/csv`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CreateCustomContactDataSource(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/locations/${req["locationId"]}/data-sources/custom-contact`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetDataSource(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/locations/${req["locationId"]}/data-sources/${req["sourceId"]}?${fm.renderURLSearchParams(req, ["locationId", "sourceId"])}`, { method: "GET" });
    },
    UpdateDataSource(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/locations/${req["locationId"]}/data-sources/${req["sourceId"]}`, { method: "PUT" });
    },
    DeleteDataSource(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/locations/${req["locationId"]}/data-sources/${req["sourceId"]}?${fm.renderURLSearchParams(req, ["locationId", "sourceId"])}`, { method: "DELETE" });
    },
    AuthenticateDataSource(fn, req) {
        return fn(`/syncapp/integrations-service/authenticate`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ResetDataSourceCredentials(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/locations/${req["locationId"]}/data-sources/${req["sourceId"]}/credentials/reset`, { method: "POST" });
    },
    GetSyncAppDownloadURL(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/locations/${req["locationId"]}/data-sources/${req["sourceId"]}/download-url?${fm.renderURLSearchParams(req, ["locationId", "sourceId"])}`, { method: "GET" });
    },
    GetInstallationInformation(fn, req) {
        try {
            fm.validateUrlParam(req["integrationName"], "integrationName");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/integrations/${req["integrationName"]}/installation-information?${fm.renderURLSearchParams(req, ["integrationName"])}`, { method: "GET" });
    },
    GetDemoLocationDataSources(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/integrations-service/demo-locations/${req["locationId"]}/data-sources?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
};
